export default __webpack_public_path__ + "static/media/401-error-unauthorized-pana.747722ac.svg";